import { getAuthRoutes } from '@shared/logto/vue';
import { BlankLayout } from '@shared/naive-ui';
import { ErrorView } from '@shared/utils';
import { createRouter, createWebHistory } from 'vue-router';
import { dashboardRoutes } from './features/dashboard';
import { debugRoutes } from './features/debug';
import { historyRoutes } from './features/history';
import { machinesRoutes } from './features/machines';
import { missionsRoutes } from './features/missions';
import { splsRoutes } from './features/spls';
import { storesRoutes } from './features/stores';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: 'error',
      path: '/error',
      component: ErrorView,
      meta: {
        layout: BlankLayout,
      },
    },
    ...getAuthRoutes({
      layout: BlankLayout,
    }),
    ...debugRoutes,
    ...missionsRoutes,
    {
      path: '/mission/:missionId',
      component: () => import('./features/missions/pages/MissionRootPage.vue'),
      children: [
        {
          path: 'updater',
          name: 'mission.updater',
          component: () => import('./features/missions/pages/MissionUpdaterPage.vue'),
        },
        ...machinesRoutes,
        ...storesRoutes,
        ...splsRoutes,
        ...historyRoutes,
        ...dashboardRoutes,
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: ErrorView,
      meta: {
        layout: BlankLayout,
      },
      props: {
        notFound: true,
      },
    },
  ],
});
